<template>
    <v-container>

    <div class="text-xs-center pt-2">
        <h2>Επικοινωνία</h2>
        <hr/>
    </div>
        <v-layout row class="justify-center">
            <div>
                <br>
        <h3>Μπορείτε να επικοινωνήσετε με το Γραφείο Αρωγής Χρηστών Εύδοξος</h3><br>
        <!--<h3>Προσωρινά μπορείτε να επικοινωνείτε με το Γραφείο Αρωγής Χρηστών Εύδοξος μόνο μέσω ηλεκτρονικής επικοινωνίας.</h3>-->
            <!--<p>Για οποιαδήποτε απορία παρακαλούμε να υποβάλετε το ερώτημά σας μέσω της ειδικής φόρμας επικοινωνίας που υπάρχει στον-->
                <!--<a href="https://eudoxus.gr/OnlineReport.aspx" target="_blank" class="red&#45;&#45;text">ιστότοπο</a> της υπηρεσίας.</p><br>-->
        <li>υποβάλλοντας  <a href="https://eudoxus.gr/contact" target="_blank">ηλεκτρονικά</a>  το ερώτημά σας, ή</li>
        <li>τηλεφωνικά στο 215 215 7850  </li>
                <br>
        <p>Ώρες λειτουργίας Γραφείου: Δευτέρα έως Παρασκευή 09:00 - 17:00</p>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        data: () => ({
            tag: 'Hello'
        }),
        name: 'ContactUs'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
